import React, { useState, useEffect } from 'react';
import CollegePageContainer from '../../Container/CollegePageContainer';
import JobListingForm from './JobListingForm';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createUserObject } from '../../Profile/profile.utils';
import { API } from '../../../API';
import { notify } from 'react-notify-toast';
import { getListingData, getDays, validateForm } from '../utils';
import UnsavedChangesPopup from '../../../Components/UnsavedChangesPopup/UnsavedChangesPopup';

const _ = require('lodash')

const PostJobDraft = (props) => {
  const previousState = props.location.state || {
    days: [],
    responsibilities: [],
    benefits: [],
    expertise: [],
    tags: {
      elt: [],
      bsb: [],
      chc: [],
      fns: [],
      fsk: [],
      shb: [],
      ict: [],
      sit: [],
      tech: [],
    },
    selected_tags: [],
    interview_requested: true,
  };

  const [state, setState] = useState({
    is_dirty: false,
    _id: previousState.id || '',
    title: previousState.title || '',
    level: previousState.level || '',
    is_vet: previousState.is_vet || false,
    qual_name: previousState.qual_name || '',
    course_code: previousState.course_code || '',
    location: previousState.location || (props.campuses.length ? props.campuses[0]._id : ''),
    online: previousState.online || false,
    delivery_mode: previousState.delivery_mode || 'online_home',
    weekly_hours: previousState.weekly_hours || '',
    monday: previousState.days.includes('monday'),
    tuesday: previousState.days.includes('tuesday'),
    wednesday: previousState.days.includes('wednesday'),
    thursday: previousState.days.includes('thursday'),
    friday: previousState.days.includes('friday'),
    saturday: previousState.days.includes('saturday'),
    sunday: previousState.days.includes('sunday'),
    flexible_days: previousState.days.includes('flexible_days'),
    start_date: previousState.start_date || null,
    end_date: previousState.end_date || null,
    close_date: previousState.close_date || null,
    tags: previousState.tags || [],
    selected_tags: previousState.selected_tags || [],
    description: previousState.description || '',
    responsibility_1: previousState.responsibilities[0] || '',
    responsibility_2: previousState.responsibilities[1] || '',
    responsibility_3: previousState.responsibilities[2] || '',
    benefit_1: previousState.benefits[0] || '',
    benefit_2: previousState.benefits[1] || '',
    benefit_3: previousState.benefits[2] || '',
    expertise_1: previousState.expertise[0] || '',
    expertise_2: previousState.expertise[1] || '',
    expertise_3: previousState.expertise[2] || '',
    display_salary: !previousState.salary_display_option,
    salary_type: previousState.salary_display_option ? '' : 'annual_salary',
    salary_min:
      (previousState.salary_type === 'hourly_salary'
        ? previousState.hourly_rate_min
        : previousState.salary_min) || 0,
    salary_max:
      (previousState.salary_type === 'hourly_salary'
        ? previousState.hourly_rate_max
        : previousState.salary_max) || 0,
    salary_unit:
      (previousState.salary_type === 'hourly_salary'
        ? previousState.hourly_rate_unit
        : previousState.salary_unit) || '',
    salary_display_option: previousState.salary_display_option || '',
    instant_hire: !previousState.interview_requested || false,
    org_pro_visible: previousState.org_pro_visible || false,
    timezone: previousState.timezone || '',
    no_of_roles: previousState.no_of_roles || 1,
  });

  const [qualificationList, setQualificationList] = useState()
  const [levels, setVETLevel] = useState([])

  useEffect(() => {
    API.getQualificationList().then(result => {
      const qualifications = result?.data?.data

      let levels = []
			let levelPriorities = []
			qualifications.filter(item => item.type === 'vet').forEach((item => {
				const subQualifications = item.qualifications
				subQualifications.forEach(ele => {
					if (!levels.includes(ele.level) && ele.level?.length) {
						levels.push(ele.level)
						levelPriorities.push({
							name: ele.level,
							priority: ele.priority
						})
					}
					else if(levels.includes(ele.level) && ele.level?.length && ele.priority) {
						const itemIndex = levelPriorities.findIndex(item => item.name === ele.level)
						levelPriorities = [
						  ...levelPriorities.slice(0, itemIndex),
						  {
							name: ele.level,
							priority: ele.priority
						  },
						  ...levelPriorities.slice(itemIndex + 1)
						]
					}
				})
			}))

			levels.sort((a, b) => {
				const priorityA = levelPriorities.find(item => item.name === a)?.priority || 0;
				const priorityB = levelPriorities.find(item => item.name === b)?.priority || 0;
				return priorityA - priorityB;
			})

      setQualificationList(qualifications)
      setVETLevel(levels)
    })

  }, [])

  const handleFormFieldChange = (e) => {
    setState({
      ...state,
      [e.target.id]: e.target.value,
      is_dirty: true,
    });
  };

  const handleCheckboxChange = (e) => {
    let newState = {
      [e.target.id]: e.target.checked,
      is_dirty: true,
    };

    if (e.target.id === 'display_salary') {
      newState.salary_type = e.target.checked ? 'annual_salary' : '';
      newState.salary_display_option = !e.target.checked ? 'Award Rates' : '';
    }

    if (e.target.id === 'is_elt') {
      newState.is_vet = false;
    }

    setState({
      ...state,
      ...newState,
    });
  };

  const handleDateChange = (date, field) => {
    setState({
      ...state,
      [field]: date,
      is_dirty: true,
    });
  };

  const handleDeliveryModeChange = (e) => {
    setState({
      ...state,
      delivery_mode: e.target.id,
      is_dirty: true,
    });
  };

  const handleRemunerationChange = (e) => {
    setState({
      ...state,
      salary_type: e.target.value,
      is_dirty: true,
    });
  };

  const handleCurrencyValueChange = (name, value) => {
    setState({
      ...state,
      [name]: Number(value) || 0,
      is_dirty: true,
    });
  };

  const handleTagsChange = (tags) => {
    setState({
      ...state,
      selected_tags: tags,
      is_dirty: true,
    })
  }

  const handleRadioChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.title,
      is_dirty: true,
    });
  };

  const tabs = [
    {
      text: 'My Vacancies',
      pathname: '/MyListings',
    },
    {
      text: 'New Vacancy',
      pathname: '/PostJobDraft',
      active: true,
    },
  ];

  const onDraft = () => {
    const listingData = getListingData(state, props.user, props.institution);
    listingData.status = 'draft';
    delete listingData.salary_type;

    if (state._id) {
      listingData._id = state._id;
      API.updateListing(listingData)
        .then((res) => {
          notify.show('Draft saved successfully');
          setState({ ...state, is_dirty: false });
        })
        .catch((err) => {
          console.log(err.response);
          notify.show('Error saving draft');
        });
    } else {
      API.createListing(listingData)
        .then((res) => {
          setState({
            ...state,
            _id: res.data._id,
            is_dirty: false,
          });
          notify.show('Draft saved successfully');
        })
        .catch((err) => {
          console.log(err);
          notify.show('Error saving draft');
        });
    }
  };

  const onPreview = (e) => {
    e.preventDefault();
    const campus = props.campuses.find((c) => c._id === state.location) || {};
    let errors = validateForm(state, campus);

    if (!errors) {
      let listingData = getListingData(state, props.user, props.institution);
      listingData._id = state._id;
      setState({ ...state, is_dirty: false });
      props.history.push('/PostJobPreview', { listing_data: listingData, type: 'new', confirmNav: true });
    }
  };

  const onCancel = () => {
    props.history.push('/MyListings');
  };

  return (
    <CollegePageContainer header='Job Board' tabs={tabs} user={props.user}>
      <UnsavedChangesPopup is_dirty={state.is_dirty} />
      {qualificationList?.length && levels?.length && <JobListingForm
        state={state}
        handleFormFieldChange={handleFormFieldChange}
        handleCheckboxChange={handleCheckboxChange}
        handleDateChange={handleDateChange}
        handleRemunerationChange={handleRemunerationChange}
        handleCurrencyValueChange={handleCurrencyValueChange}
        handleTagsChange={handleTagsChange}
        handleDeliveryModeChange={handleDeliveryModeChange}
        handleRadioChange={handleRadioChange}
        onDraft={onDraft}
        onSubmit={onPreview}
        onCancel={onCancel}
        campuses={props.campuses}
        qualifications={qualificationList}
        levels={levels}
        selectedList={state.selected_tags}
        user={props.user}
      />}
    </CollegePageContainer>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses || [],
  };
}

export default connect(mapStateToProps)(withRouter(PostJobDraft));
